class H7UndoToast extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.message = this.querySelector('[data-h7-undo-message]');
    this.button = this.querySelector('[data-h7-undo-action]');
    this.button?.addEventListener('click', () => this.undo());
    window.H7UndoToast = this;
  }

  disconnectedCallback() {
    if (window.H7UndoToast === this) delete window.H7UndoToast;
    // Rearm on reconnect after a section re-render.
    this.ready = false;
  }

  show({ message, actionLabel, onUndo, duration = 7000 } = {}) {
    window.clearTimeout(this.timer);
    this.onUndo = typeof onUndo === 'function' ? onUndo : null;
    if (this.message) this.message.textContent = message || '';
    if (this.button) this.button.textContent = actionLabel || this.dataset.defaultAction || 'Undo';
    this.hidden = false;
    this.timer = window.setTimeout(() => this.hide(), duration);
  }

  hide() {
    window.clearTimeout(this.timer);
    this.hidden = true;
    this.onUndo = null;
  }

  undo() {
    const handler = this.onUndo;
    this.hide();
    // Handlers surface their own failures; this backstop only stops an async
    // handler from becoming an unhandled rejection.
    Promise.resolve()
      .then(() => handler?.())
      .catch(() => {});
  }
}

if (!customElements.get('h7-undo-toast')) {
  customElements.define('h7-undo-toast', H7UndoToast);
}
